import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-text-columns-carousel]',
  swiperWrapper: '[data-swiper-wrapper]',
};

const classes = {
  swiperWrapper: 'swiper-wrapper',
  swiperPagination: '.swiper-pagination',
};

class IconTextColumns extends HTMLElement {
  constructor() {
    super();

    this.breakpoint = window.matchMedia('(min-width:767px)');

    this.carouselWrappers = this.querySelector(selectors.carouselWrapper);

    this.swiperWrapper = this.carouselWrappers.querySelector(
      selectors.swiperWrapper
    );

    this.initCarousels();

    // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
    // If not, it will get destroyed.
    this.registerEventListeners();
  }

  initCarousels() {
    if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy();
      this.swiperWrapper.classList.remove(classes.swiperWrapper);
    }

    if (this.breakpoint.matches === false) {
      // Only add the wrapper class if the breakpoints initialise and we need to create the swiper.
      this.swiperWrapper.classList.add(classes.swiperWrapper);

      this.carousel = new Swiper(this.carouselWrappers, {
        modules: [Navigation, Pagination],
        freeMode: true,
        slidesPerView: 'auto',
        spaceBetween: 40,
        watchOverflow: true,
        hashNavigation: {
          watchState: true,
        },
        pagination: {
          el: classes.swiperPagination,
          clickable: true,
        },
      });
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('text-columns', IconTextColumns);
